export const PRODUCT_TERM = 'Map Print' // Poster
export const CTA = 'Create Your Poster' // Create your poster
export const CTA_SMALL = 'Create Poster' // Create your poster
